import { Banner, Button, Card, Icon, Layout, Link, Page, TextField, Spinner, Divider } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { devIsSidenav } from '../../dev_store/slice/side_navbar';
import { getAppOverViewDetails } from '../../dev_services/developer/api';
import { fetchDataFailure, fetchDataStart, fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import {
    HideIcon
} from '@shopify/polaris-icons';
import {
    ClipboardIcon
} from '@shopify/polaris-icons';
import {
    ViewIcon
} from '@shopify/polaris-icons';


export default function AppOverView() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { appID } = useParams();
    const [app_Key, setAppKey] = useState("");
    const [app_secrate, setappsecrate] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    // Function to toggle the visibility state
    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    // Function to handle copying text to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                console.log('Text copied to clipboard:', text);
                toast.success("Text copied to clipboard");
            })
            .catch((error) => {
                console.error('Error copying text to clipboard:', error);
                toast.error("Error copying text to clipboard");
            });
    };

    const appsResponseData = useSelector((state: any) => state.appsOverviewSlice);
    const { data, loadings, errorr } = appsResponseData;
    console.log("my new Data" + appsResponseData.data?.app_id)

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching data...");
                dispatch(fetchDataStart());

                // Fetching data from the API
                const response = await getAppOverViewDetails(appID);
                const slugName = response.slug;
                localStorage.setItem('slug', slugName);
                dispatch(fetchDataSuccess(response));
                setAppKey(response.credentials.api_key)
                setappsecrate(response.credentials.api_secret)
            } catch (error) {
                console.log("Fetched dashboard dataError:");
                console.error("Error fetching dashboard data:", error);
                toast.error("Error fetching data");
            }
        };

        // Fetch data only if appsResponseData is undefined or empty
        if (!data) {
            fetchData();
        } else {
            // Set state variables from the fetched data
            setAppKey(data.credentials.api_key)
            setappsecrate(data.credentials.api_secret)
        }
    }, [dispatch, appID, data]);


    // Show loading spinner until data is fetched
    if (loadings) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
                <Spinner size="large" />
                <div style={{ marginTop: '20px' }}>
                    <a >Please wait...</a>
                </div>
            </div>
        );
    }

    // Show error banner if there's an error
    if (errorr) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Banner >{error}</Banner>
            </div>
        );
    }

    // Render content screen once data is fetched
    return (
        <div className="developer-page-frame" style={{ backgroundColor: "#f6f6f7" ,paddingLeft: "2.0rem", paddingRight: "2.0rem" ,paddingTop: "25px" }}>
        <ToastContainer style={{ paddingTop: "50px" }} />
        <div style={{  backgroundColor: "#f6f6f7" }}>
        <div >
                    <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
                        App Overview
                    </label>
                </div>

            {/* <label style={{ fontFamily: "sfpromedium", fontWeight: "500" }} className="font-medium text-lg">Overview</label> */}
            <div className="pt-9">
                {/* <label style={{ fontFamily: "sfpromedium", fontWeight: "400" }} className="font-medium text-base w-full sm:w-48">Create A New APP</label> */}
                <div>
                    <ToastContainer style={{ top: "60px" }} /> {/* Add ToastContainer here */}
                    <Card>
                        <div  style={{}}>
                            <div className="">
                                <div style={{ width: "auto" }}>

                                    <label style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}>Client credentials</label>
                                    <div className="mt-4 top-5" style={{ fontSize: "15px" }}>
                                        <TextField
                                            label="Client ID"
                                            autoComplete="Client ID"
                                            value={app_Key} // Make sure appOverViewData is not undefined before accessing slug
                                            suffix={
                                                <a href="/your-second-link" onClick={(e) => { e.preventDefault(); copyToClipboard(app_Key); }}>
                                                    <Icon source={ClipboardIcon} tone="base" />
                                                </a>
                                            } />

                                    </div>
                                    <div className="mt-4" style={{ fontSize: "15px" }}>
                                        <TextField
                                            label="Client secret"
                                            autoComplete="Client secret"
                                            type={isPasswordVisible ? 'text' : 'password'} // Toggle the input type
                                            value={app_secrate}
                                            suffix={
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <a href="/your-first-link" onClick={(e) => { e.preventDefault(); togglePasswordVisibility(); }}>
                                                        <Icon source={isPasswordVisible ? ViewIcon : HideIcon} tone="base" />
                                                    </a>
                                                    <a href="/your-second-link" onClick={(e) => { e.preventDefault(); copyToClipboard(app_secrate); }}>
                                                        <Icon source={ClipboardIcon} tone="base" />
                                                    </a>
                                                </div>
                                            }
                                        />

                                    </div>
                                    <div className="mt-4">
                                        <p>
                                            Use these client credentials to <Link url="/">access the Shiprocket API from your app.</Link> They’re also available on the
                                            <Link url="/">API access page.</Link>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

        </div>

    </div>

    )
}
